import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';

import { getOrganizationEmployee, getDepartment } from 'actions/asyncActions';
import EmployeesTable from '../table/EmployeesTable';

@withAsyncActions({
    getOrganizationEmployee: getOrganizationEmployee
        .withPayload(props => ({
            organizationId: props.id
        }))
        .withOptions({ dispatchOnMount: true, resetOnUnmount: true }),
    getDepartment: getDepartment
        .withPayload(props => ({
            company: props.id
        }))
        .withOptions({ dispatchOnMount: true, resetOnUnmount: true }),
})
export default class CompanyStructure extends Component {
    render() {
        const { getOrganizationEmployee: { data: employees  }, getDepartment: { data: departments }, type } = this.props;

        return (
            <EmployeesTable
                employees={employees}
                departments={departments}
                companyType={type}
            />
        );
    }
}
